import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

/**
 * The company logo in the top bar: the tenant's own logo when it has one, the Factor KPI logo otherwise.
 * A tenant logo that cannot be loaded (the file is gone, or the address is unreachable) falls back to the
 * Factor KPI logo too, instead of showing a broken image.
 */
@Component({
    selector: 'app-logo',
    template: `
        <div class="logo-container">
            <ng-container *ngIf="tenantLogoUrl; else defaultLogo">
                <img [src]="tenantLogoUrl" alt="Company logo" class="tenant-logo" [height]="56" [width]="56" (error)="onTenantLogoError()" />
            </ng-container>

            <ng-template #defaultLogo>
                <img src="assets/images/auth/kpi-logo.svg" width="100" height="100" alt="FactorKPI - Smart Performance Management" />
            </ng-template>
        </div>
    `,
    imports: [NgIf],
    styles: [
        `
            .logo-container {
                width: 56px;
                height: 56px;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            :host {
                display: inline-block;
            }

            .tenant-logo {
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
            }
        `
    ]
})
export class Logo {
    @Input() logoUrl: string | null | undefined;

    /** The address that failed to load, so a different logo (after the tenant changes it) is tried again. */
    private failedLogoUrl: string | null = null;

    get tenantLogoUrl(): string | null {
        return this.logoUrl && this.logoUrl !== this.failedLogoUrl ? this.logoUrl : null;
    }

    onTenantLogoError(): void {
        this.failedLogoUrl = this.logoUrl ?? null;
    }
}
